<div class="container">
  <form class="card-form" [formGroup]="kycForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate>
    <div class="blue-top">
      <span class="blue-top-title">Enter Personal Details</span>
    </div>

    <div class="card-section top-section">
      <h1><b>Enter your personal and next of kin details below</b></h1>

      <!-- Personal Details -->
      <mat-form-field appearance="outline" class="form-select">
        <mat-label>Email address</mat-label>
        <input matInput formControlName="emailAddress" type="email">
        <mat-error *ngIf="kycForm.get('emailAddress')?.touched && kycForm.get('emailAddress')?.hasError('required')">
          Email address is required
        </mat-error>
        <mat-error *ngIf="kycForm.get('emailAddress')?.touched && kycForm.get('emailAddress')?.hasError('email')">
          Please enter a valid email address
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label>Phone number</mat-label>
        <input matInput formControlName="phoneNumber" placeholder="07...">
        <mat-error *ngIf="kycForm.get('phoneNumber')?.touched && kycForm.get('phoneNumber')?.hasError('required')">
          Phone number is required
        </mat-error>
        <mat-error *ngIf="kycForm.get('phoneNumber')?.touched && kycForm.get('phoneNumber')?.hasError('pattern')">
          Please enter a valid phone number e.g. 07XX XXXXXX
        </mat-error>
      </mat-form-field>

      <div class="section-divider"></div>

      <!-- Next of Kin -->
      <h2 class="section-heading"><b>Next of Kin Details</b></h2>

      <div formArrayName="nextOfKin">
        <div *ngFor="let kin of nextOfKin.controls; let i = index" [formGroupName]="i" class="kin-card">

          <div class="kin-card-header" *ngIf="nextOfKin.length > 1">
            <span class="kin-index">Next of Kin {{ i + 1 }}</span>
            <button type="button" class="remove-kin-btn" (click)="removeNextOfKin(i)">Remove</button>
          </div>

          <mat-form-field appearance="outline" class="form-select">
            <mat-label>Full Name</mat-label>
            <input matInput formControlName="fullName">
            <mat-error *ngIf="kin.get('fullName')?.touched && kin.get('fullName')?.invalid">
              Full name is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-select">
            <mat-label>Relationship</mat-label>
            <mat-select formControlName="relationship">
              <mat-option *ngFor="let r of relationships" [value]="r">{{ r }}</mat-option>
            </mat-select>
            <mat-error *ngIf="kin.get('relationship')?.touched && kin.get('relationship')?.invalid">
              Relationship is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-select">
            <mat-label>Email address</mat-label>
            <input matInput formControlName="emailAddress" type="email">
            <mat-error *ngIf="kin.get('emailAddress')?.touched && kin.get('emailAddress')?.hasError('required')">
              Email address is required
            </mat-error>
            <mat-error *ngIf="kin.get('emailAddress')?.touched && kin.get('emailAddress')?.hasError('email')">
              Please enter a valid email address
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-select">
            <mat-label>Phone number</mat-label>
            <input matInput formControlName="phoneNumber" placeholder="07...">
            <mat-error *ngIf="kin.get('phoneNumber')?.touched && kin.get('phoneNumber')?.hasError('required')">
              Phone number is required
            </mat-error>
            <mat-error *ngIf="kin.get('phoneNumber')?.touched && kin.get('phoneNumber')?.hasError('pattern')">
              Please enter a valid phone number e.g. 07XX XXXXXX
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-select">
            <mat-label>Share %</mat-label>
            <input matInput formControlName="sharePercent" type="number" min="1" max="100">
            <mat-hint>Proportion of the benefit payable to the next of kin. All shares must total 100%.</mat-hint>
            <mat-error *ngIf="kin.get('sharePercent')?.touched && kin.get('sharePercent')?.invalid">
              Share percentage is required (1–100)
            </mat-error>
          </mat-form-field>

          <div class="section-divider" *ngIf="i < nextOfKin.length - 1"></div>
        </div>
      </div>

      <div class="share-error" *ngIf="sharePercentError">
        Total share percentage must equal 100%. Currently: {{ totalSharePercent }}%
      </div>

      <button type="button" class="add-kin-btn" (click)="addNextOfKin()">
        + Add another Next of Kin
      </button>

      <div class="row-div">
        <button mat-button type="submit" [disabled]="kycForm.invalid || sharePercentError || isSubmitting">
          <span class="button-text">{{ isSubmitting ? 'Submitting...' : 'Save and Continue' }}</span>
        </button>
      </div>
    </div>
  </form>
</div>
